import { render, staticRenderFns } from "./VendorStatus.vue?vue&type=template&id=17a35ae0&scoped=true&"
import script from "./VendorStatus.vue?vue&type=script&lang=js&"
export * from "./VendorStatus.vue?vue&type=script&lang=js&"
import style0 from "./VendorStatus.vue?vue&type=style&index=0&id=17a35ae0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a35ae0",
  null
  
)

export default component.exports